<div  *ngIf="!isLogin || (route === '/home' || route === '/privacy-policy'|| route === '/who-are-we' ) || !isAdmin">
    <div>
      <app-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; z-index: 1000;"></app-nav-bar>
    </div>
    <div class="main-content" >
      <router-outlet></router-outlet>
    </div>
</div>

<div *ngIf="isAdmin && isLogin && route !== '/home'  && route !== '/privacy-policy' && route !== '/who-are-we'">
    <div class="d-flex justify-content-start" >
        <div>
            <app-side-bar></app-side-bar>
        </div>
        <div class="main-div ">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

